import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Button, Col, Modal, ModalBody } from "reactstrap";
import Loader from "src/components/Loader";
import { putInvoicedPackage } from "src/store/dashboard/saga";
import { DashboardClientPurchasedPackageDetailDto } from "src/store/dashboard/type";

const UninvoicedModal = ({
  selected,
  show,
  setShow,
  onSuccess,
}: {
  onSuccess: () => void;
  selected: DashboardClientPurchasedPackageDetailDto;
  show: boolean;
  setShow: (show: boolean) => void;
}) => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <Modal isOpen={show} toggle={() => setShow(false)}>
        <ModalBody>
          <Col md={12}>
            {loader && <Loader />}
            <table className="pack-table w-100">
              <tr>
                <th>{t("Dashboard.Package")}:</th>
                <td>
                  {selected.PackageName}
                  <i
                    className="bx bx-info-circle"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShow(true)}
                  />
                </td>
              </tr>
              <tr>
                <th>{t("Dashboard.PurchaseDate")}:</th>
                <td>
                  {moment(selected.PurchaseDate).format("DD/MM/YYYY HH:mm:ss")}
                </td>
              </tr>
              <tr>
                <th>{t("Dashboard.PackStartDate")}:</th>
                <td>
                  {moment(selected.PackStratDate).format("DD/MM/YYYY HH:mm:ss")}
                </td>
              </tr>
              <tr>
                <th>{t("Dashboard.PackEndDate")}:</th>
                <td>
                  {moment(selected.PackEndDate).format("DD/MM/YYYY HH:mm:ss")}
                </td>
              </tr>
              <tr>
                <th>{t("Dashboard.Amount")}:</th>
                <td>{selected.Amount}</td>
              </tr>
            </table>
            {selected.ClientPayments && (
              <table className="pack-table w-100 my-3">
                <tr>
                  <th>{t("Dashboard.PaymentType")}:</th>
                  <td>{selected.ClientPayments.PaymentTypeName}</td>
                </tr>
                <tr>
                  <th>{t("Dashboard.Amount")}:</th>
                  <td>{selected.ClientPayments.Amount}</td>
                </tr>
                <tr>
                  <th>{t("Dashboard.IyziCommissionFee")}:</th>
                  <td>{selected.ClientPayments.IyziCommissionFee}</td>
                </tr>
                <tr>
                  <th>{t("Dashboard.IyziCommissionRateAmount")}:</th>
                  <td>{selected.ClientPayments.IyziCommissionRateAmount}</td>
                </tr>
                <tr>
                  <th>{t("Dashboard.IyzicoPaymentID")}:</th>
                  <td>{selected.ClientPayments.IyzicoPaymentID}</td>
                </tr>
              </table>
            )}
          </Col>
          <div className="d-flex justify-content-end mt-5">
            <Button
              color="success"
              type="submit"
              onClick={() => {
                setLoader(true);
                dispatch(
                  putInvoicedPackage({
                    payload: {
                      onSuccess: () => {
                        setLoader(false);
                        toast.success(t("Dashboard.InvoiceSuccessMessage"), {
                          theme: "colored",
                        });
                        setShow(false);
                        onSuccess();
                      },
                      onError: (message) => {
                        toast.error(message);
                      },
                    },
                    id: selected.Id,
                  })
                );
              }}
            >
              {t("Dashboard.Invoiced")}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
export default UninvoicedModal;
